"use client";

interface WowSpellTooltipProps {
  name: string;
  rank?: string;
  cost?: string;
  range?: string;
  castTime?: string;
  description: string;
  flavor?: string;
}

/** WoW-style spell tooltip body. Render inside a TooltipContent. */
export function WowSpellTooltip({
  name,
  rank,
  cost,
  range,
  castTime,
  description,
  flavor,
}: WowSpellTooltipProps) {
  return (
    <div className="flex flex-col gap-0.5 text-left text-[13px] leading-snug">
      <div className="flex items-baseline justify-between gap-4">
        <span className="text-base font-bold text-[#ffd100]">{name}</span>
        {rank ? <span className="text-xs text-[#9d9d9d]">{rank}</span> : null}
      </div>
      {cost || range ? (
        <div className="flex justify-between gap-4 text-white">
          <span>{cost}</span>
          <span>{range}</span>
        </div>
      ) : null}
      {castTime ? <div className="text-white">{castTime}</div> : null}
      <p className="mt-1 text-[#ffd100]">{description}</p>
      {flavor ? <p className="mt-1 italic text-[#9d9d9d]">{flavor}</p> : null}
    </div>
  );
}
